import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import Spinner from '../../../App/Components/Spinner/Spinner'
import { useAppDispatch, useAppSelector } from '../../../App/Hooks/reduxHooks'
import { ILastMinute } from '../Client/ILastMinute'
import { getLastMinutes } from '../Store/Actions'
import View from '../View/View'

import style from './Overview.scss'

const Overview = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const lastMinutes = useAppSelector(state => state.lastMinutes.list)

  useEffect(() => {
    if (!lastMinutes) {
      dispatch(getLastMinutes())
    }
  }, [])

  if (typeof lastMinutes === 'undefined') {
    return (
      <div className={style.container}>
        <h1>{t('Last minutes')}</h1>
        <Spinner />
      </div>
    )
  }

  return (
    <>
      <div className={style.container}>
        <h1>{t('Last minutes')}</h1>

        {0 === lastMinutes.length && <div>No last minutes found</div>}

        {lastMinutes.map((lastMinute: ILastMinute) => (
          <View lastMinute={lastMinute} />
        ))}
      </div>
    </>
  )
}

export default Overview
